import { DetailsPanelActionTypes, PreviewContent } from './types';
import { action } from 'typesafe-actions';
import { v4 as UUIDV4 } from 'uuid';

export const getEnquiryDetailsStart = (payload: any) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_START, payload);
export const getEnquiryDetailsSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_SUCCESS, payload);
export const getEnquiryDetailsFailure = (error: string) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_FAILURE, error);

export const updateEnquiryDetailsStart = (payload: any) =>
  action(DetailsPanelActionTypes.UPDATE_ENQUIRY_DETAILS_START, payload);
export const updateEnquiryDetailsSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.UPDATE_ENQUIRY_DETAILS_SUCCESS, payload);
export const updateEnquiryDetailsFailure = (error: string) =>
  action(DetailsPanelActionTypes.UPDATE_ENQUIRY_DETAILS_FAILURE, error);

export const getReferralDetailsStart = (payload: any) =>
  action(DetailsPanelActionTypes.GET_REFERRAL_DETAILS_START, payload);
export const getReferralDetailsSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.GET_REFERRAL_DETAILS_SUCCESS, payload);
export const getReferralDetailsFailure = (payload: any) =>
  action(DetailsPanelActionTypes.GET_REFERRAL_DETAILS_FAILURE, payload);

export const setEnquiryReferralsDetails = (payload: any) =>
  action(DetailsPanelActionTypes.SET_ENQUIRY_REFERRALS, payload);

export const downloadCombinedPDFStart = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_START, payload);
export const downloadCombinedPDFSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_SUCCESS, payload);
export const downloadCombinedPDFFailure = (error: string) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_FAILURE, error);

export const downloadCombinedZIPStart = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_START, payload);
export const downloadCombinedZIPSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_SUCCESS, payload);
export const downloadCombinedZIPFailure = (error: string) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_FAILURE, error);

export const downloadPartialZipStart = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_PARTIAL_ZIP_START, payload);
export const downloadPartialZipSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_PARTIAL_ZIP_SUCCESS, payload);
export const downloadPartialZipFailure = (error: string) =>
  action(DetailsPanelActionTypes.DOWNLOAD_PARTIAL_ZIP_FAILURE, error);

export const viewAttachmentStart = (payload: any, download = true) =>
  action(DetailsPanelActionTypes.VIEW_ATTACHMENT_START, {
    ...payload,
    download
  });
export const viewAttachmentSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.VIEW_ATTACHMENT_SUCCESS, payload);
export const viewAttachmentFailure = (error: string) =>
  action(DetailsPanelActionTypes.VIEW_ATTACHMENT_FAILURE, error);

export const downloadAttachmentStart = (
  url: string,
  fileName: string,
  contentType: string
) =>
  action(DetailsPanelActionTypes.DOWNLOAD_ATTACHMENT_START, {
    url,
    fileName,
    contentType
  });
export const downloadAttachmentSuccess = () =>
  action(DetailsPanelActionTypes.DOWNLOAD_ATTACHMENT_SUCCESS);
export const downloadAttachmentFailure = (error: string) =>
  action(DetailsPanelActionTypes.DOWNLOAD_ATTACHMENT_FAILURE, error);

export const setPreviewContent = (content: PreviewContent | undefined) =>
  action(DetailsPanelActionTypes.SET_PREVIEW_CONTENT, content);

export const getEnquiryAutoRenewPropertiesStart = (payload: any) =>
  action(
    DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_PROPERTIES_START,
    payload
  );
export const getEnquiryAutoRenewPropertiesSuccess = (payload: any) =>
  action(
    DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS,
    payload
  );
export const getEnquiryAutoRenewPropertiesFailure = (error: string) =>
  action(
    DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE,
    error
  );

export const editEnquiryAutoRenewStart = (payload: any) =>
  action(DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_START, payload);
export const editEnquiryAutoRenewSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_SUCCESS, payload);
export const editEnquiryAutoRenewFailure = (error: string) =>
  action(DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_FAILURE, error);
export const editEnquiryAutoRenewReset = () =>
  action(DetailsPanelActionTypes.EDIT_ENQUIRY_AUTO_RENEW_RESET);

export const archiveEnquiryStart = (payload: any) =>
  action(DetailsPanelActionTypes.ARCHIVE_ENQUIRY_START, payload);
export const archiveEnquirySuccess = (payload: any) =>
  action(DetailsPanelActionTypes.ARCHIVE_ENQUIRY_SUCCESS, payload);
export const archiveEnquiryFailure = (error: string) =>
  action(DetailsPanelActionTypes.ARCHIVE_ENQUIRY_FAILURE, error);

export const uploadAttachmentStart = (
  enquiryId: number,
  file: File,
  assetOwnerId?: number
) =>
  action(DetailsPanelActionTypes.UPLOAD_ATTACHMENT_START, {
    enquiryId,
    file,
    assetOwnerId,
    uuid: UUIDV4()
  });
export const uploadAttachmentSuccess = (uuid: string) =>
  action(DetailsPanelActionTypes.UPLOAD_ATTACHMENT_SUCCESS, {
    uuid
  });
export const uploadAttachmentFailure = (
  uuid: string,
  error: string,
  enquiryId: number,
  assetOwnerId?: number
) =>
  action(DetailsPanelActionTypes.UPLOAD_ATTACHMENT_FAILURE, {
    enquiryId,
    assetOwnerId,
    uuid,
    error
  });
export const clearUploadAttachmentErrors = (uuid: string) =>
  action(DetailsPanelActionTypes.CLEAR_UPLOAD_ATTACHMENT_ERROR, { uuid });

export const deleteAttachmentStart = (
  id: number,
  enquiryId: number,
  assetOwnerId?: number
) =>
  action(DetailsPanelActionTypes.DELETE_ATTACHMENT_START, {
    id,
    enquiryId,
    assetOwnerId
  });
export const deleteAttachmentSuccess = (id: number) =>
  action(DetailsPanelActionTypes.DELETE_ATTACHMENT_SUCCESS, id);
export const deleteAttachmentFailure = (id: number, error: string) =>
  action(DetailsPanelActionTypes.DELETE_ATTACHMENT_FAILURE, { id, error });
export const clearDeleteAttachmentErrors = (id: number) =>
  action(DetailsPanelActionTypes.CLEAR_UPLOAD_ATTACHMENT_ERROR, { id });

export const moveEnquiryTeamStart = (payload: any) =>
  action(DetailsPanelActionTypes.MOVE_ENQUIRY_TEAM_START, payload);
export const moveEnquiryTeamSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.MOVE_ENQUIRY_TEAM_SUCCESS, payload);
export const moveEnquiryTeamFailure = (error: string) =>
  action(DetailsPanelActionTypes.MOVE_ENQUIRY_TEAM_FAILURE, error);

export const updateAttachmentStart = (payload: any) =>
  action(DetailsPanelActionTypes.UPDATE_ATTACHMENT_START, payload);
export const updateAttachmentSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.UPDATE_ATTACHMENT_SUCCESS, payload);
export const updateAttachmentFailure = (error: string) =>
  action(DetailsPanelActionTypes.UPDATE_ATTACHMENT_FAILURE, error);
export const updateAttachmentClear = (payload: any) =>
  action(DetailsPanelActionTypes.UPDATE_ATTACHMENT_CLEAR, payload);

export const getEnquiryAutoRenewSeriesStart = (payload: any) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_SERIES_START, payload);
export const getEnquiryAutoRenewSeriesSuccess = (payload: any) =>
  action(
    DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_SERIES_SUCCESS,
    payload
  );
export const getEnquiryAutoRenewSeriesFailure = (error: string) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_AUTO_RENEW_SERIES_FAILURE, error);

export const addEventStart = (payload: any) =>
  action(DetailsPanelActionTypes.ADD_EVENT_START, payload);
export const addEventSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.ADD_EVENT_SUCCESS, payload);
export const addEventFailure = (error: string) =>
  action(DetailsPanelActionTypes.ADD_EVENT_FAILURE, error);
